import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OESchoolTargetType = {
    biology:        'biology',
    chemistry:      'chemistry',
    geography:      'geography',
    physics:        'physics',
    math:           'math'
};

OESchoolTargetType.all = [
    OESchoolTargetType.biology,
    OESchoolTargetType.chemistry,
    OESchoolTargetType.geography,
    OESchoolTargetType.physics,
    OESchoolTargetType.math
];

export const OESchoolStartSelectionContent = {
    [OESchoolTargetType.biology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.animalCell,
                        OETargetMenuDefs.plantCell,
                        OETargetMenuDefs.schoolCellDivision,
                        OETargetMenuDefs.humanBonesSchool,
                        OETargetMenuDefs.schoolSkull,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanBrainNeuron,
                        OETargetMenuDefs.humanBrainSynapse,
                        OETargetMenuDefs.humanMuscleSpindle,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanSkinEpidermis,
                        OETargetMenuDefs.humanSkin2,
                        OETargetMenuDefs.virusSarscov2,
                        OETargetMenuDefs.humanGenitalMale,
                        OETargetMenuDefs.humanKnee,
                        OETargetMenuDefs.animalSnail,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.chemistry]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.schoolFormelsammlung,
                        OETargetMenuDefs.schoolToxin,
                        OETargetMenuDefs.schoolAtomicModel,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.geography]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.schoolSouthAmerica,
                        OETargetMenuDefs.schoolVolcano,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.physics]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.techEngineOtto,
                        OETargetMenuDefs.schoolSolarSystem,
                        OETargetMenuDefs.schoolRefrigerator,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.math]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.schoolGeometrie,
                    ]
                }
            ]
        }
    ],

    [OESchoolTargetType.biology + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.animalCell,
                        OETargetMenuDefs.plantCell,
                        OETargetMenuDefs.schoolCellDivision,
                        OETargetMenuDefs.humanBonesSchool,
                        OETargetMenuDefs.schoolSkull,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanBrainNeuron,
                        OETargetMenuDefs.humanBrainSynapse,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanSkinEpidermis,
                        OETargetMenuDefs.humanSkin2,
                        OETargetMenuDefs.virusSarscov2,
                        OETargetMenuDefs.humanKnee,
                        OETargetMenuDefs.animalSnail,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.chemistry + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.schoolFormelsammlung,
                        OETargetMenuDefs.schoolToxin,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.geography + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.schoolSouthAmerica,
                        OETargetMenuDefs.schoolVolcano,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.physics + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.techEngineOtto,
                        OETargetMenuDefs.schoolSolarSystem,
                        OETargetMenuDefs.schoolRefrigerator,
                    ]
                }
            ]
        }
    ],

    [OESchoolTargetType.biology + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.animalCell,
                        OETargetMenuDefs.plantCell,
                        OETargetMenuDefs.schoolCellDivision,
                        OETargetMenuDefs.humanBonesSchool,
                        OETargetMenuDefs.schoolSkull,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanBrainNeuron,
                        OETargetMenuDefs.humanBrainSynapse,
                        OETargetMenuDefs.humanMuscleSpindle,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanSkin2,
                        OETargetMenuDefs.humanKnee,
                        OETargetMenuDefs.animalSnail,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.chemistry + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.schoolFormelsammlung,
                        OETargetMenuDefs.schoolToxin,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.geography + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.schoolSouthAmerica,
                        OETargetMenuDefs.schoolVolcano,
                    ]
                }
            ]
        }
    ],
    [OESchoolTargetType.physics + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.techEngineOtto,
                        OETargetMenuDefs.schoolSolarSystem,
                        OETargetMenuDefs.schoolRefrigerator,
                    ]
                }
            ]
        }
    ],
};

OESchoolStartSelectionContent.modules = [
    {id: OESchoolTargetType.biology, icon: OEIconCodes.school.biologyTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.biology]},
    {id: OESchoolTargetType.chemistry, icon: OEIconCodes.school.chemistryTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.chemistry]},
    {id: OESchoolTargetType.geography, icon: OEIconCodes.school.geographyTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.geography]},
    {id: OESchoolTargetType.physics, icon: OEIconCodes.school.physicsTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.physics]},
    {id: OESchoolTargetType.math, icon: OEIconCodes.school.mathTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.math]}
];

OESchoolStartSelectionContent.modulesBeta = [
    {id: OESchoolTargetType.biology, icon: OEIconCodes.school.biologyTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.biology + OEAlphaBetaProdTypes.beta]},
    {id: OESchoolTargetType.chemistry, icon: OEIconCodes.school.chemistryTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.chemistry + OEAlphaBetaProdTypes.beta]},
    {id: OESchoolTargetType.geography, icon: OEIconCodes.school.geographyTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.geography + OEAlphaBetaProdTypes.beta]},
    {id: OESchoolTargetType.physics, icon: OEIconCodes.school.physicsTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.physics + OEAlphaBetaProdTypes.beta]},
    ///{id: OESchoolTargetType.math, icon: OEIconCodes.school.mathTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.math]}
];

OESchoolStartSelectionContent.modulesProduction = [
    {id: OESchoolTargetType.biology, icon: OEIconCodes.school.biologyTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.biology + OEAlphaBetaProdTypes.prod]},
    {id: OESchoolTargetType.chemistry, icon: OEIconCodes.school.chemistryTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.chemistry + OEAlphaBetaProdTypes.prod]},
    {id: OESchoolTargetType.geography, icon: OEIconCodes.school.geographyTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.geography + OEAlphaBetaProdTypes.prod]},
    {id: OESchoolTargetType.physics, icon: OEIconCodes.school.physicsTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.physics + OEAlphaBetaProdTypes.prod]},
    //{id: OESchoolTargetType.math, icon: OEIconCodes.school.mathTarget, categories: OESchoolStartSelectionContent[OESchoolTargetType.math]}
];